import React, { useState } from 'react'
import axios from '../../../library/axios'
import { MySwal } from '../../../library/swal'
import Button from 'react-bootstrap/Button'
import { getSlug, } from "../../../../src/config/routes/guards/slug";

const EditModuleComp = (props) => {

    const [loading, setLoading] = useState(false)
    const [disabled, setDisabled] = useState(false)
    const [module, setModule] = useState(props.module.namaModule)
    const [path, setPath] = useState(props.module.pathModule)

    const handleUpdate = () => {
        setLoading(true)
        setDisabled(true)

        const requestBody = {
            namaModule: module,
            pathModule: path,
        }
        // console.log(requestBody)
        // return false
        axios({
            url: `/modules/update/${props?.module?.id}`,
            method: 'PATCH',
            data: requestBody,
            headers: { Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}` },
        })
            .then(res => {
                // console.log(res)
                // return false
                if (res.status === 200) {
                    MySwal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: 'Successfully updated Module!'
                    })

                    setLoading(false)
                    setDisabled(false)

                    props.close()
                    props.fetch()
                }
            })
            .catch(err => {
                setLoading(false)
                setDisabled(false)
                if (err !== "") {
                    console.log(err?.response)
                    MySwal.fire({
                        icon: 'error',
                        title: 'Oops, Error!',
                        text: `${err?.response?.data?.messages}`
                    })
                }
            })
    }

    return (
        <div>
            <div className="mb-3 row">
                <label htmlFor="module" className="col-sm-2 col-form-label">Modul</label>
                <div className="col-sm-10">
                    <input type="text" className="form-control" id="module" onChange={(e) => setModule(e.target.value)} value={module} />
                </div>
            </div>
            <div className="mb-3 row">
                <label htmlFor="path" className="col-sm-2 col-form-label">Path</label>
                <div className="col-sm-10">
                    <input type="text" className="form-control" id="path" onChange={(e) => setPath(e.target.value)} value={path} />
                </div>
            </div>
            <div className="mt-5 row">
                <div className="col-12">
                    <Button variant="danger" size="sm" onClick={() => props.close()}>
                        Tutup
                    </Button>
                    &nbsp;
                    <Button disabled={disabled} variant="success" size="sm" onClick={() => handleUpdate()}>{loading === true ? 'Mohon Tunggu..' : 'Simpan'}</Button>
                </div>
            </div>
        </div>
    )
}

export default EditModuleComp
